import styled, { css } from 'styled-components';
import { ReactComponent as ChevronLeft } from 'assets/img/icons/chevron-left.svg';
import { th, variants } from 'style/theme';

export const DatePickerContainer = styled.div`
  width: 100%;

  .react-datepicker {
    border: none;
    border-radius: 20px;
    font-family: Inter;
    background-color: ${th('colors.fountainBlue+4')};
    box-shadow: ${th('shadows.smallShadow')};
  }

  .react-datepicker-popper {
    z-index: 10;
  }

  .react-datepicker__header {
    background-color: ${th('colors.fountainBlue+4')};
    border-radius: 20px;
    border-bottom: none;

    select {
    }
  }

  .react-datepicker__input-container,
  .react-datepicker-wrapper {
    width: 100%;
  }

  .react-datepicker__day--selected,
  .react-datepicker__day--in-selecting-range,
  .react-datepicker__day--in-range {
    background-color: ${th('colors.turquoise')};
    border-radius: 50%;
  }
`;

export const StyledSelectedDate = styled.button`
  position: relative;
  width: 100%;
  padding: 8px 20px 8px 12px;
  border-radius: 16px;
  border: none;
  font-size: 16px;
  text-align: left;
  background-color: ${th('colors.pickledBluewood4')};
  color: ${th('colors.pickledBluewood')};
  font-family: Inter;

  ${variants('variant', {
    large: css`
      padding: 16px 20px 16px 12px;
      font-weight: 500;
    `
  })};

  ${variants('color', {
    transparentWhite: css`
      background-color: ${th('colors.transparentWhite75')};
    `
  })};

  > svg {
    position: absolute;
    right: 20px;
    top: 50%;
    transform: translateY(-50%);
    color: ${th('colors.silverGray')};
  }
`;

export const Label = styled.div`
  font-size: 12px;
  margin-bottom: 4px;
  color: ${th('colors.pickledBluewood2')};
`;

export const ChevronRight = styled(ChevronLeft)`
  transform: rotate(180deg);
`;

export const MonthHeader = styled.div`
  margin: ${th('space.1')}px ${th('space.2')}px;
  display: flex;
  justify-content: space-between;

  > button {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    padding: 0;
    border: none;
    border-radius: 50%;
    background-color: ${th('colors.fountainBlue+3')};
    font-size: 20px;
    cursor: pointer;

    > svg {
      width: 16px;
      height: 16px;
      flex-shrink: 0;
      fill: ${th('colors.pickledBluewood')};
    }

    :disabled {
      background-color: ${th('colors.pickledBluewood45')};

      > svg {
        fill: ${th('colors.pickledBluewood3')};
      }
    }
  }

  > select {
    font-size: 14px;
    font-weight: 600;
    font-family: Inter;
    background-color: ${th('colors.fountainBlue+4')};
    color: ${th('colors.black')};
  }
`;
